package com.iregained.site.components.sections.resources.styles

import com.varabyte.kobweb.compose.css.*
import com.varabyte.kobweb.compose.css.functions.calc
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import com.varabyte.kobweb.silk.style.base
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.css.AlignItems

val ResourcesHeroContainerStyle = CssStyle.base {
    Modifier.fillMaxWidth().styleModifier { property("height", "calc(100dvh - 80px)") }
        .minHeight(600.px)
        .position(Position.Relative)
        .overflow(Overflow.Hidden)
}

val ResourcesHeroVideoStyle = CssStyle {
    base {
        Modifier.position(Position.Absolute).top((-20).px).bottom((-20).px).left(0.px).width(100.percent)
            .height(calc { 100.percent + 10.px }).minWidth(100.percent).minHeight(100.percent).margin(0.px)
            .display(DisplayStyle.Block) // FIX 1: Removes the inline text gap
            .objectFit(ObjectFit.Cover).scale(1.05)
    }
}

val ResourcesHeroBgStyle = CssStyle.base {
    Modifier.position(Position.Absolute).top(0.px).left(0.px).width(100.percent).height(100.percent)
        .objectFit(ObjectFit.Cover)
}

val ResourcesHeroOverlayStyle = CssStyle.base {
    Modifier.position(Position.Absolute).top(0.px).left(0.px).width(100.percent).height(100.percent)
        // Deep, academic slate/navy overlay (85% opacity) to make text highly legible
        .backgroundColor(rgba(15, 23, 42, 0.85f))
}

val ResourcesHeroContentStyle = CssStyle.base {
    Modifier.fillMaxWidth().maxWidth(900.px).padding(leftRight = 24.px, topBottom = 60.px)
        .position(Position.Relative) // Sits above the absolute background/overlay
        .display(DisplayStyle.Flex).flexDirection(FlexDirection.Column).alignItems(AlignItems.Center)
}

val ResourcesHeroHeadlineStyle = CssStyle.base {
    Modifier.color(Colors.White).fontSize(3.cssRem).fontWeight(FontWeight.Bold).textAlign(TextAlign.Center)
        .lineHeight(1.2).margin(bottom = 24.px).whiteSpace(WhiteSpace.PreWrap)
}

val ResourcesHeroSubheadlineStyle = CssStyle.base {
    Modifier.color(Colors.White.copyf(alpha = 0.85f)).fontSize(1.15.cssRem).maxWidth(1200.px).fontWeight(FontWeight.Normal)
        .textAlign(TextAlign.Center).lineHeight(1.6)
}